import { PLAN_META, type CheckoutPlanId } from './metaPixel'

/** Explicit checkbox ids — read straight off the DOM at click time. */
export const UPSELL_IDS = {
  braveMind: 'upsell-brave-mind',
  littleEngineer: 'upsell-little-engineer',
  focusLab: 'upsell-focus-lab',
} as const

function go(url: string): void {
  console.log('GOING TO:', url)
  window.location.href = url
}

/**
 * Every case written out by name. No keys, no arrays, no concatenation —
 * each URL below is a complete literal string.
 */
export function goToCheckout(
  plan: CheckoutPlanId,
  braveMind: boolean,
  littleEngineer: boolean,
  focusLab: boolean,
  value: number,
): void {
  window.fbq?.('track', 'InitiateCheckout', {
    value,
    currency: 'USD',
    content_name: PLAN_META[plan].contentName,
    content_type: 'product',
  })

  if (plan === 'complete') {
    if (braveMind && littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49902595670258:1,49945662128370:1',
      )
    if (braveMind && littleEngineer && !focusLab)
      return go(
        'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49902595670258:1',
      )
    if (braveMind && !littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49945662128370:1',
      )
    if (braveMind && !littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960131133682:1,49930211688690:1')
    if (!braveMind && littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960131133682:1,49902595670258:1,49945662128370:1',
      )
    if (!braveMind && littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960131133682:1,49902595670258:1')
    if (!braveMind && !littleEngineer && focusLab)
      return go('https://myeasyguide.online/cart/49960131133682:1,49945662128370:1')
    if (!braveMind && !littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960131133682:1')
  }

  if (plan === 'starter') {
    if (braveMind && littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49902595670258:1,49945662128370:1',
      )
    if (braveMind && littleEngineer && !focusLab)
      return go(
        'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49902595670258:1',
      )
    if (braveMind && !littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49945662128370:1',
      )
    if (braveMind && !littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960130478322:1,49930211688690:1')
    if (!braveMind && littleEngineer && focusLab)
      return go(
        'https://myeasyguide.online/cart/49960130478322:1,49902595670258:1,49945662128370:1',
      )
    if (!braveMind && littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960130478322:1,49902595670258:1')
    if (!braveMind && !littleEngineer && focusLab)
      return go('https://myeasyguide.online/cart/49960130478322:1,49945662128370:1')
    if (!braveMind && !littleEngineer && !focusLab)
      return go('https://myeasyguide.online/cart/49960130478322:1')
  }
}
